"use client";

import { Button, VStack, chakra } from "@chakra-ui/react";
import { HeadingLevelBoundary, Hx } from "src/components/Heading/Heading";
import { NextLink } from "src/components/NextLink";
import { useTranslatedString } from "src/i18n/hooks";

export const DisabledMessage: React.FC = () => {
	const t = useTranslatedString();

	return (
		<HeadingLevelBoundary>
			<VStack spacing={4} justifyContent="center" minHeight="60vh">
				<Hx size="h4">{t("premiumCalc.disabled.title")}</Hx>
				<chakra.p>{t("premiumCalc.disabled.text")}</chakra.p>

				<NextLink passHref href="/">
					<chakra.span>
						<Button
							as="a"
							href="/"
							id="product_disabled_back_to_home"
							mt={6}
						>
							{t("heroBackLink.to.home")}
						</Button>
					</chakra.span>
				</NextLink>
			</VStack>
		</HeadingLevelBoundary>
	);
};

// 🔬 TBD
